<template>
    <div v-if="countriesLoaded">
        <div v-for="entry in question.propertyInfo.type.containedPropertyEntries">
            <div v-if="entry.fragment.value == 'firstname'" class="lableFormContainer">
                <label>Vorname</label>
                <input type="text" v-model="question.answer.value.firstname" id="firstname">
            </div>
            <div v-if="entry.fragment.value == 'lastname'" class="lableFormContainer">
                <label>Nachname</label>
                <input type="text" v-model="question.answer.value.lastname" id="lastname">
            </div>
            <div v-if="entry.fragment.value == 'street'" class="lableFormContainer">
                <label>Straße</label>
                <input type="text" v-model="question.answer.value.street" id="street">
            </div>
            <div v-if="entry.fragment.value == 'number'" class="lableFormContainer">
                <label>Hausnummer</label>
                <input type="text" v-model="question.answer.value.number" id="streetno">
            </div>
            <div v-if="entry.fragment.value == 'zip'"  class="lableFormContainer">
                <label>PLZ</label>
                <input type="text" v-model="question.answer.value.zip" id="zip">
            </div>
            <div v-if="entry.fragment.value == 'city'" class="lableFormContainer">
                <label>Ort</label>
                <input type="text" v-model="question.answer.value.city" id="city">
            </div>
            <div v-if="entry.fragment.value == 'country'"  class="lableFormContainer">
                <label>Land</label>
                <select v-model="question.answer.value.country" id="country">
	                <option v-for="country in countries" v-bind:value="country">{{ country }}</option>
	            </select>
            </div>
        </div>
    </div>
</template>

<script>
   export default {
	   name: 'address-question',
	   props: {
		   question: Object
	   },
	   data: function() {
	       return {
	    	   countries: [],
	    	   countriesLoaded: false
	       }
	   },
	   created: function() {
		   this.loadCountries();
	   },
	   methods: {
		   loadCountries: function() {
			   jQuery.ajax ({
	                url: '/getCountryChoices',
	                type: 'GET',
	                dataType: "json",
	                success: this.loadCountriesSuccess,
	                error: function() {alert("error2");}
	            });
		   },
		   loadCountriesSuccess: function(data) {
               this.countries = data;
               if (this.question.answer.value.country === undefined 
                        || this.countries.indexOf(this.question.answer.value.country) === -1) {
                    if(this.countries.indexOf('Deutschland')>-1) {
                        this.question.answer.value.country = 'Deutschland';
                    }
               }
	           this.countriesLoaded = true;
	       },
	       onValidate: function() {
	    	   var answer = this.question.answer;
	    	   var hasError = false;
	    	   this.question.propertyInfo.type.containedPropertyEntries.forEach(function(entry){
                   let key = entry.fragment['value'];
                   let value = answer.value[key];
                   let id;
                   let valid;
                   if(key === 'number'){
                       //geänderte Id
                       id = 'streetno';
                       valid = !(value === undefined || value.trim().length == 0);
                   }
                   else if(key === 'zip'){
                       //numerisch und 4-5 Zeichen lang
                       id = key;
                       valid = (value !== undefined && (value.trim().length == 4 || value.trim().length == 5) && jQuery.isNumeric(value));
                   }
                   else{
                       id = key;
                       valid = !(value === undefined || value.trim().length == 0);
                   }
                   console.debug(id+"("+key + "): "+ value + " is valid="+valid);
                   if(!valid){
                       hasError = true;
                   }
               });
	    	   return hasError;
	       }
	   }
   }
</script>



// WEBPACK FOOTER //
// AddressQuestion.vue?a488baba